import { ListItemIcon, ListItemText, MenuItem, type MenuItemProps } from '@mui/material'
import { Favorite } from '@tunasong/icons'
import { type FC } from 'react'
import { useFavorites } from './favorites.hook.js'
import type { FavoriteControlProps } from './favorite-props.js'

type FavoriteMenuItemProps = FavoriteControlProps<MenuItemProps>

export const FavoriteMenuItem: FC<FavoriteMenuItemProps> = props => {
  const { onClick, entity, ...restProps } = props
  const { toggleFavorite, isFavorite, getFavoriteTemplateFromEntity } = useFavorites()

  const favorite = isFavorite(entity)

  return (
    <MenuItem
      onClick={ev => {
        ev.preventDefault()
        ev.stopPropagation()
        toggleFavorite(getFavoriteTemplateFromEntity(entity))
        if (onClick) {
          onClick(ev)
        }
      }}
      {...restProps}
    >
      <ListItemIcon>
        <Favorite color={favorite ? 'error' : 'inherit'} />
      </ListItemIcon>
      <ListItemText primary={favorite ? 'Remove from Favorites' : 'Add to Favorites'} />
    </MenuItem>
  )
}

export default FavoriteMenuItem
